import {useCallback, useEffect, useState} from "react";

export const useHash = (): [string, (a: string) => void] => {
  const [hash, setHash] = useState(() => window.location.hash);

  const hashChangeHandler = useCallback(() => {
    setHash(window.location.hash);
  }, []);

  useEffect(() => {
    window.addEventListener('hashchange', hashChangeHandler);
    return () => {
      window.removeEventListener('hashchange', hashChangeHandler);
    };
  }, [hashChangeHandler]);

  useEffect(() => {
    window.addEventListener('popstate', hashChangeHandler);
    return () => {
      window.removeEventListener('popstate', hashChangeHandler);
    };
  }, [hashChangeHandler]);

  const updateHash = useCallback(
    newHash => {
      if (newHash !== hash) window.location.hash = newHash;
    },
    [hash]
  );

  return [hash, updateHash];
};